import OpenGraph from 'components/OpenGraph'
import config from 'common/config'

const Uninstalling = (props) => {
  return (
    <>
      <OpenGraph
        title="Uninstalling"
        // TODO:
        // description=""
      />
      <p className="m-3 font-light text-xl text-gray-500 text-center">
        This is a placeholder - more content to come.
      </p>
    </>
  )
}

Uninstalling.title = `Uninstalling ${config.appName}`
export default Uninstalling
